import { Listbox, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Fragment } from 'react';
import { AiFillCaretDown } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';

export type SelectDropdownOption = {
  value: string;
  name: string;
};

interface ISelectDropdown {
  current: SelectDropdownOption;
  options: SelectDropdownOption[];
  label?: string;
  onChange: (option: SelectDropdownOption) => void;
  className?: string;
}

const SelectDropdown = ({
  current,
  onChange,
  options,
  label,
  className,
}: ISelectDropdown) => {
  return (
    <Listbox value={current} onChange={onChange}>
      <div className={clsx('relative z-10 mt-1', className)}>
        <Listbox.Button className="relative flex w-full cursor-default items-center gap-2 py-2 pl-3 text-left text-base text-cream md:text-lg">
          {label && (
            <div className="text-base font-light text-cream md:text-lg">
              {label}{' '}
            </div>
          )}
          <span className="block truncate">{current.name}</span>
          <span className="pointer-events-none inset-y-0 right-0 flex items-center pr-2">
            <AiFillCaretDown
              className="h-5 w-5 text-cream"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute w-full rounded-md bg-blackAlt/75 py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none md:text-lg">
            <div className="absolute left-0 top-0 z-20 h-1 w-full rounded-t-md bg-blueAlt-500" />
            {options.map((o) => (
              <Listbox.Option
                key={o.value}
                className={({ active }) =>
                  clsx(
                    `relative cursor-pointer select-none py-2 pl-10 pr-4 text-cream`,
                    active && 'underline'
                  )
                }
                value={o}
              >
                <>
                  <span
                    className={clsx(
                      `block truncate`,
                      current.value === o.value ? 'font-medium' : 'font-normal'
                    )}
                  >
                    {o.name}
                  </span>
                  {current.value === o.value ? (
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-cream">
                      <FaCheck className="h-4 w-4" aria-hidden="true" />
                    </span>
                  ) : null}
                </>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

export default SelectDropdown;
